import { render } from "./fixedTab.vue?vue&type=template&id=d6eb1fca"
import script from "./fixedTab.vue?vue&type=script&lang=js"
export * from "./fixedTab.vue?vue&type=script&lang=js"

import "./fixedTab.vue?vue&type=style&index=0&id=d6eb1fca&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__